// Ongelmakartta v3 (#1389): systemic_map.v3 — the `ongelmakarttaV3` namespace.
// v2's screen keeps its strings under `systemicMapV2`.

export const ongelmakarttaV3Fi = {
  pivots: 'Vipupisteet',
  list: {
    empty: 'Vipupisteitä ei ole vielä haettu.',
    intro: 'Kuution ehdotuksia: tekoäly muotoili nämä osallistujien juurisyistä ja niiden lähteistä. Napauta vipupistettä nähdäksesi sen perustelut.',
    sections: { konsensus: 'Yhteiset näkemykset', kiistanalainen: 'Kiistanalaiset', villi_kortti: 'Villit kortit', sokea_piste: 'Sokeat pisteet' },
    leads: {
      konsensus: 'Instrumentit, jotka useampi juurisyy jakaa ja joita osallistujat pitävät osuvina.',
      kiistanalainen: 'Osallistujien arviot jakautuvat näissä, tai juurisyyt haluaisivat liikuttaa samaa instrumenttia eri suuntiin: kannattaa keskustella, miksi.',
      villi_kortti: 'Juurisyitä, joita mikään yhteinen instrumentti ei pidä, joita osallistujat eivät vielä tue tai jotka pari lisäsi itse: yllättäviä vipuja.',
      sokea_piste: 'Kuutio on analysoinut työpajan, ja kirjallisuuden ja tutkimuksen perusteella nämä voisivat olla tämän ryhmän sokeita pisteitä.',
    },
    reach: '{{juurisyyt}} juurisyytä · {{ongelmat}} ongelmaa',
    sources: '{{n}} lähdettä',
    score: 'Pisteet',
    split: 'Jakautuu {{n}}/100',
    openTitle: 'Avoimet kysymykset',
    openLead: 'Näitä mekanismeja moni juurisyy jakaa, mutta niille ei löytynyt instrumenttia. Ne ovat osallistujien kysymyksiä, eivät vipupisteitä.',
    openReach: '{{n}} juurisyytä',
  },
  all: 'Ongelmakartta',
  voteTab: 'Äänestys',
  vote: {
    notOpen: 'Äänestys ei ole vielä auki. Fasilitaattori avaa sen, kun vipupisteet on käyty läpi.',
    open: 'Valitse vipupisteet, joiden kanssa haluat jatkaa: {{left}} / {{max}} ääntä jäljellä. Napauta uudelleen ottaaksesi äänen takaisin.',
    closed: 'Äänestys on päättynyt: {{voters}} laitetta äänesti. Äänet ohjaavat keskustelua; fasilitaattori valitsee jatkoon vietävät.',
    noneLeft: 'Kaikki {{max}} ääntä on annettu. Ota yksi takaisin valitaksesi toisen.',
    votes: '{{count}} ääntä',
    chosen: 'Valittu jatkoon',
  },
  pivotsCount: 'Vipupisteet, {{count}} vipupistettä',
  replayEntry: 'Toista animaatio',
  mapDynamic: 'Kartan tila: Dynaaminen',
  mapStatic: 'Kartan tila: Staattinen',
  resetLayout: 'Palauta asettelu',
  loading: 'Ladataan ongelmakarttaa…',
  empty: 'Kartalla ei ole vielä ongelmia.',
  error: 'Ongelmakarttaa ei voitu ladata',
  pivot: {
    close: 'Sulje',
    types: { konsensus: 'Yhteinen näkemys', kiistanalainen: 'Kiistanalainen', villi_kortti: 'Villi kortti', sokea_piste: 'Sokea piste' },
    precision: { pykala: 'Pykälätaso', saados: 'Säädöstaso', mekanismi: 'Mekanismi', rakenne: 'Rakenne' },
    aiMark: 'Kuution ehdotus: tekoäly muotoili tämän osallistujien juurisyistä ja niiden lähteistä',
    blindSpotIntro: 'Kuutio on analysoinut työpajan, ja kirjallisuuden ja tutkimuksen perusteella nämä voisivat olla tämän ryhmän sokeita pisteitä.',
    reworded: 'Muotoiltu uudelleen vivuksi',
    solutionWorded: 'Muotoilu muistuttaa yhä ratkaisua',
    vagueWording: 'Otsikko on yhä epätarkka tai pitkä',
    instrument: 'Instrumentti',
    instrumentTypes: { saantely: 'Sääntely', rahoitus: 'Rahoitus', organisaatio: 'Organisaatio', sosiaalinen: 'Sosiaalinen', narratiivi: 'Narratiivi', tekninen: 'Tekninen' },
    owner: 'Omistaja',
    ownerUnlisted: 'ei työpajan toimijalistalla',
    mandate: { aihe: 'aiheen hallinnoija', toimeksiantaja: 'toimeksiantajan listalla' },
    direction: 'Muutossuunta',
    directions: {
      vahennetaan: 'Vähennetään', lisataan: 'Lisätään', tehdaan_nakyvaksi: 'Tehdään näkyväksi', siirretaan_vastuuta: 'Siirretään vastuuta',
      avataan: 'Avataan', puretaan: 'Puretaan', tiukennetaan: 'Tiukennetaan', kevennetaan: 'Kevennetään',
    },
    state: 'Tilamuuttuja',
    stateNow: 'Nykytila',
    hiddenState: 'Piilevä tila, ei suoraan havaittavissa',
    metric: 'Lähimittari',
    metricMissing: { ei_mitattu: 'mittari on vain ehdotettu', ei_mittaria: 'ei mittaria' },
    resisters: 'Kuka voisi vastustaa',
    loses: 'menettäisi',
    quotes: 'Lainaukset',
    evidence: 'Näyttö',
    supports: 'tukee',
    notSupported: 'ei tue väitettään',
    sourceKinds: { rag: 'Tutkimus', web: 'Verkko', juurisyy: 'Juurisyy' },
    reach: 'Ulottuvuus',
    reachLine: '{{juurisyyt}} juurisyytä · {{esteet}} estettä · {{ongelmat}} ongelmaa · {{linssit}} linssiä',
    rootCauses: 'Juurisyyt',
    signal: 'Osallistujien signaali',
    approval: 'Osuu-osuus {{n}}/100',
    opposite: 'juurisyyt haluavat liikuttaa sitä eri suuntiin',
    score: 'Pisteet',
    total: 'Yhteensä',
    none: 'ei tietoa',
    parts: { konvergenssi: 'Konvergenssi', linssihajonta: 'Linssien kirjo', naytto: 'Näyttö', validointi: 'Osallistujien arvio', toimijuus: 'Toimijuus', mitattavuus: 'Mitattavuus', katkaisee_silmukan: 'Katkaisee silmukan' },
    split: 'Kiistanalaisuus',
    splitHelp: 'Kuinka tasan osallistujien Osuu- ja Ei osu -arviot jakautuvat (1 = täysin tasan). Ei osa pisteitä.',
    values: 'Arvovalinnat',
    tests: 'Testit',
    codeOnly: 'Tarkistettu vain koodilla: viitteet, lähteet, omistaja ja muotoilu. Tekoälyarvioija ei ollut käytössä.',
    testNames: { kausaalisuus: 'Kausaalisuus', toimijuus: 'Toimijuus', todennettavuus: 'Todennettavuus', spesifisyys: 'Spesifisyys', ratkaisuavoimuus: 'Ratkaisuavoimuus' },
    solutionExamples: 'Erilaisia ratkaisuja, jotka voisivat liikuttaa tätä vipua',
    whyBlind: 'Miksi osallistujat eivät ehkä näe tätä',
  },
  admin: {
    title: 'Ongelmakartta: vipupisteet',
    actors: 'Toimijalista',
    actorsLead: 'Vipupisteiden omistajat ja vastustajat valitaan vain tästä listasta. Lista alkaa Perustiedot-sivun Keskeisimmistä toimijoista; lisää nimet, joilla juurisyyt viittaavat samaan toimijaan.',
    name: 'Nimi',
    aliases: 'Muut nimet (pilkulla erotettuina)',
    aihe: 'Aiheen hallinnoija',
    toimeksiantaja: 'Toimeksiantajan listalla',
    add: 'Lisää toimija',
    save: 'Tallenna',
    remove: 'Poista',
    saved: 'Tallennettu',
    failed: 'Tallennus epäonnistui: {{error}}',
    unmatched: 'Tunnistamattomat nimet',
    unmatchedLead: 'Juurisyyt nimeävät nämä toimijat, mutta ne eivät vastaa ketään listalla. Lisää toimijaksi tai toisen toimijan muuksi nimeksi; seuraava ajo tunnistaa ne.',
    noUnmatched: 'Viimeisimmässä ajossa ei ollut tunnistamattomia nimiä.',
    usedBy: '{{n}} juurisyyssä',
    addAsActor: 'Lisää toimijaksi',
    addAsAliasOf: 'Lisää muuksi nimeksi:',
    choose: 'Valitse toimija',
    runs: 'Ajot',
    noRuns: 'Vipupisteitä ei ole vielä haettu.',
    status: { running: 'käynnissä', done: 'valmis', budget: 'aikaraja täyttyi', failed: 'epäonnistui' },
    runLine: '{{accepted}} hyväksyttyä / {{generated}} · {{minutes}} min',
    preview: 'esikatselu: osallistujat eivät näe tätä',
    exportXlsx: 'Vie Excel',
    exportFull: 'Vie täysi (sisältää laitetunnisteet)',
    loadFailed: 'Ei voitu ladata: {{error}}',
    estimate: {
      title: 'Seuraava ajo',
      none: 'Kestoa ei voi vielä arvioida: aiempia ajoja ei ole. Aikaraja {{limit}} min; ajo päättyy siihen niillä vipupisteillä, jotka ovat valmiina.',
      judgeOff: 'Tuomari pois', judgeOn: 'Tuomari päällä',
      models: { sonnet: 'Sonnet 5.5', opus: 'Opus 5.5' },
      cell: 'noin {{minutes}} min', cellOver: 'yli {{limit}} min: päättyy aikarajaan', unknown: 'ei vielä mitattu',
      prepared: 'Valmisteltu taustalla: {{prepared}} / {{total}} juurisyytä luettu ja niiden instrumentti etsitty. Kuutio valmistelee uudet juurisyyt itse, kun niitä ei ole hetkeen muokattu, jotta ajo ehtii vipupisteisiin.',
      basis: '{{rootCauses}} juurisyytä, joista {{unread}} lukematta. Arvio {{runs}} aiemmasta ajosta ({{ownRuns}} tämän työpajan, joiden mukaan aineiston koko), tuomarin osuus {{judgedRuns}} tuomaroidusta ajosta; Opusin nopeus {{opusCalls}} mitatusta kutsusta. Mallin valinta koskee muotoilua, tuomaria ja sokeita pisteitä. Aikaraja {{limit}} min: ajo päättyy siihen niillä vipupisteillä, jotka ovat valmiina.',
    },
    vote: {
      title: 'Äänestys ja valitut vipupisteet',
      noRun: 'Vipupisteitä ei ole vielä haettu. Aja ensin Etsi vipupisteet.',
      status: {
        none: 'Äänestystä ei ole avattu.',
        open: 'Äänestys on auki: {{max}} ääntä laitetta kohden, {{voters}} laitetta äänestänyt. Osallistujat eivät näe ääniä ennen kuin suljet äänestyksen.',
        closed: 'Äänestys on suljettu: {{voters}} laitetta äänesti. Osallistujat näkevät äänet.',
      },
      maxVotes: 'Ääniä laitetta kohden',
      votesEach: '{{count}} ääntä laitetta kohden',
      open: 'Avaa äänestys',
      reopen: 'Avaa äänestys uudelleen',
      close: 'Sulje äänestys',
      chooseLead: 'Valitse vipupisteet, joiden kanssa jatketaan. Äänet ovat suuntaa antavia, valinta on sinun. Valitut ovat moduulin tuotos seuraaville vaiheille.',
      votes: '{{count}} ääntä',
      save: 'Tallenna valitut ({{count}})',
      saved: 'Tallennettu: {{count}} valittua vipupistettä',
      noneSaved: 'Valintaa ei ole vielä tallennettu.',
    },
    choice: {
      title: 'Näytettävät vipupisteet',
      lead: 'Viimeisimmän ajon vipupisteet: osallistujat näkevät {{shown}} / {{total}}. Oletuksena näkyvät tarkistuksen läpäisseet parhaat, kunkin tyypin valittu määrä; ajo tekee enemmän, ja ne, myös hylätyt, voi laittaa näkyviin tästä. Valinta tallentuu heti ja näkyy kartalla, ratkaisuissa ja tulevaisuustestauksessa.',
      noRun: 'Vipupisteitä ei ole vielä haettu. Aja ensin Etsi vipupisteet.',
      failed: 'Ei läpäissyt: {{list}}',
      held: 'Pysyy näkyvissä: siihen on kirjoitettu {{count}} ratkaisua.',
      judged: 'Tuomari: {{passed}} / {{total}} testiä läpi',
      tests: { kausaalisuus: 'syy-yhteys', toimijuus: 'toimijuus', todennettavuus: 'todennettavuus', spesifisyys: 'spesifisyys', ratkaisuavoimuus: 'ratkaisuavoimuus' },
      validators: {
        id_eheys: 'viittaukset eivät täsmää', huoneen_kattavuus: 'liian vähän osallistujien hyväksymiä juurisyitä',
        lainaus_ei_lahteessa: 'lainaus ei löydy lähteestä', instrumentti_ei_lahteessa: 'keino ei löydy lähteestä',
        kriteeri_puuttuu: 'jokin kohta puuttuu', viite_ilman_lahdetta: 'pykälä tai säädös ilman lähdettä',
        lahteistys_riittamaton: 'liian vähän lähteitä', testi_kausaalisuus: 'syy-yhteys ei vakuuta',
        testi_toimijuus: 'kukaan ei voi tarttua', testi_todennettavuus: 'ei todennettavissa', testi_spesifisyys: 'liian yleinen',
      },
    },
  },
};

export const ongelmakarttaV3En = {
  pivots: 'Vipupisteet',
  list: {
    empty: 'No vipupisteet have been looked for yet.',
    intro: 'Kuutio’s proposals: AI worded these from the participants’ root causes and their sources. Tap one to see why.',
    sections: { konsensus: 'Shared views', kiistanalainen: 'Contested', villi_kortti: 'Wild cards', sokea_piste: 'Blind spots' },
    leads: {
      konsensus: 'Instruments several root causes share and the participants hold to be right.',
      kiistanalainen: 'The participants’ verdicts split on these, or the root causes would move one instrument in opposite directions: worth discussing why.',
      villi_kortti: 'Root causes no shared instrument holds, the participants do not support yet, or a pair added itself: unexpected levers.',
      sokea_piste: 'Kuutio has analysed the workshop, and from the literature and research these could be this group’s blind spots.',
    },
    reach: '{{juurisyyt}} root causes · {{ongelmat}} problems',
    sources: '{{n}} sources',
    score: 'Score',
    split: 'Split {{n}}/100',
    openTitle: 'Open questions',
    openLead: 'Several root causes share these mechanisms, but no instrument was found for them. They are questions for the participants, not vipupisteet.',
    openReach: '{{n}} root causes',
  },
  all: 'Problem mapping',
  voteTab: 'Vote',
  vote: {
    notOpen: 'The vote is not open yet. The facilitator opens it once the leverage points have been discussed.',
    open: 'Choose the leverage points you want to work on: {{left}} of {{max}} votes left. Tap again to take a vote back.',
    closed: 'The vote has closed: {{voters}} devices voted. The votes focus the discussion; the facilitator chooses what goes forward.',
    noneLeft: 'All {{max}} votes are given. Take one back to choose another.',
    votes: '{{count}} votes',
    chosen: 'Chosen to go forward',
  },
  pivotsCount: 'Vipupisteet, {{count}} pivot points',
  replayEntry: 'Replay the animation',
  mapDynamic: 'Map mode: Dynamic',
  mapStatic: 'Map mode: Static',
  resetLayout: 'Reset the layout',
  loading: 'Loading the problem map…',
  empty: 'There are no problems on the map yet.',
  error: 'The problem map could not be loaded',
  pivot: {
    close: 'Close',
    types: { konsensus: 'Shared view', kiistanalainen: 'Contested', villi_kortti: 'Wild card', sokea_piste: 'Blind spot' },
    precision: { pykala: 'Section level', saados: 'Statute level', mekanismi: 'Mechanism', rakenne: 'Structure' },
    aiMark: 'Kuutio’s proposal: AI worded this from the participants’ root causes and their sources',
    blindSpotIntro: 'Kuutio has analysed the workshop, and from the literature and research these could be this group’s blind spots.',
    reworded: 'Reworded as a lever',
    solutionWorded: 'The wording still reads like a solution',
    vagueWording: 'The title is still vague or long',
    instrument: 'Instrument',
    instrumentTypes: { saantely: 'Regulation', rahoitus: 'Funding', organisaatio: 'Organisation', sosiaalinen: 'Social', narratiivi: 'Narrative', tekninen: 'Technical' },
    owner: 'Owner',
    ownerUnlisted: 'not on the workshop’s actor list',
    mandate: { aihe: 'governs the topic', toimeksiantaja: 'on the commissioner’s list' },
    direction: 'Direction of change',
    directions: {
      vahennetaan: 'Reduce', lisataan: 'Increase', tehdaan_nakyvaksi: 'Make visible', siirretaan_vastuuta: 'Shift responsibility',
      avataan: 'Open up', puretaan: 'Dismantle', tiukennetaan: 'Tighten', kevennetaan: 'Ease',
    },
    state: 'State variable',
    stateNow: 'The state now',
    hiddenState: 'A hidden state, not directly observable',
    metric: 'Nearest indicator',
    metricMissing: { ei_mitattu: 'the indicator is only proposed', ei_mittaria: 'no indicator' },
    resisters: 'Who might resist',
    loses: 'would lose',
    quotes: 'Quotes',
    evidence: 'Evidence',
    supports: 'supports',
    notSupported: 'does not support its claim',
    sourceKinds: { rag: 'Research', web: 'Web', juurisyy: 'Root cause' },
    reach: 'Reach',
    reachLine: '{{juurisyyt}} root causes · {{esteet}} obstacles · {{ongelmat}} problems · {{linssit}} lenses',
    rootCauses: 'Root causes',
    signal: 'The participants’ signal',
    approval: 'Osuu share {{n}}/100',
    opposite: 'the root causes would move it in opposite directions',
    score: 'Score',
    total: 'Total',
    none: 'no data',
    parts: { konvergenssi: 'Convergence', linssihajonta: 'Lens spread', naytto: 'Evidence', validointi: 'The participants’ verdict', toimijuus: 'Agency', mitattavuus: 'Measurability', katkaisee_silmukan: 'Breaks a loop' },
    split: 'Split',
    splitHelp: 'How evenly the participants’ Osuu and Ei osu verdicts split (1 = exactly even). Not part of the score.',
    values: 'Value choices',
    tests: 'Tests',
    codeOnly: 'Checked by code only: references, sources, owner and wording. The AI judge was not used.',
    testNames: { kausaalisuus: 'Causality', toimijuus: 'Agency', todennettavuus: 'Verifiability', spesifisyys: 'Specificity', ratkaisuavoimuus: 'Solution-openness' },
    solutionExamples: 'Different solutions that could move this lever',
    whyBlind: 'Why the participants may not see this',
  },
  admin: {
    title: 'Problem mapping: vipupisteet',
    actors: 'Actor list',
    actorsLead: 'A vipupiste’s owner and opponents are chosen from this list only. It starts from Basic info’s key actors; add the names the root causes use for the same actor.',
    name: 'Name',
    aliases: 'Other names (comma-separated)',
    aihe: 'Governs the topic',
    toimeksiantaja: 'On the commissioner’s list',
    add: 'Add an actor',
    save: 'Save',
    remove: 'Remove',
    saved: 'Saved',
    failed: 'Saving failed: {{error}}',
    unmatched: 'Unmatched names',
    unmatchedLead: 'The root causes name these actors, but they match no one on the list. Add one as an actor or as another actor’s name; the next run will match it.',
    noUnmatched: 'The latest run had no unmatched names.',
    usedBy: 'in {{n}} root causes',
    addAsActor: 'Add as an actor',
    addAsAliasOf: 'Add as a name of:',
    choose: 'Choose an actor',
    runs: 'Runs',
    noRuns: 'No vipupisteet have been looked for yet.',
    status: { running: 'running', done: 'done', budget: 'time budget reached', failed: 'failed' },
    runLine: '{{accepted}} accepted / {{generated}} · {{minutes}} min',
    preview: 'preview: the participants do not see it',
    exportXlsx: 'Export Excel',
    exportFull: 'Export in full (includes device ids)',
    loadFailed: 'Could not load: {{error}}',
    estimate: {
      title: 'The next run',
      none: 'No estimate yet: there are no earlier runs. Limit {{limit}} min; the run ends there with the vipupisteet ready by then.',
      judgeOff: 'Judge off', judgeOn: 'Judge on',
      models: { sonnet: 'Sonnet 5.5', opus: 'Opus 5.5' },
      cell: 'about {{minutes}} min', cellOver: 'over {{limit}} min: ends at the limit', unknown: 'not measured yet',
      prepared: 'Prepared in the background: {{prepared}} of {{total}} root causes read and their instrument searched for. Kuutio prepares new root causes by itself once they have been left alone a moment, so the run has time for the vipupisteet.',
      basis: '{{rootCauses}} root causes, {{unread}} of them unread. Estimated from {{runs}} earlier runs ({{ownRuns}} of this workshop, which set the material’s size), the judge’s share from {{judgedRuns}} judged runs; Opus’s speed from {{opusCalls}} measured calls. The model applies to the wording, the judge and the blind spots. Time limit {{limit}} min: the run ends there with the vipupisteet ready by then.',
    },
    vote: {
      title: 'Vote and chosen leverage points',
      noRun: 'No leverage points yet. Run Find leverage points first.',
      status: {
        none: 'The vote has not been opened.',
        open: 'The vote is open: {{max}} votes per device, {{voters}} devices have voted. The participants do not see the votes until you close it.',
        closed: 'The vote is closed: {{voters}} devices voted. The participants see the votes.',
      },
      maxVotes: 'Votes per device',
      votesEach: '{{count}} votes per device',
      open: 'Open the vote',
      reopen: 'Open the vote again',
      close: 'Close the vote',
      chooseLead: 'Choose the leverage points to work on. The votes are a guide; the choice is yours. The chosen ones are the module\u2019s output for the next steps.',
      votes: '{{count}} votes',
      save: 'Save the chosen ({{count}})',
      saved: 'Saved: {{count}} chosen leverage points',
      noneSaved: 'No choice saved yet.',
    },
    choice: {
      title: 'Vipupisteet shown',
      lead: 'The latest run\u2019s vipupisteet: the participants see {{shown}} of {{total}}. By default the best that passed the checks are shown, as many of each type as chosen; the run makes more, and they, the rejected too, can be shown from here. A change saves at once and shows on the map, in the solutions and in the future testing.',
      noRun: 'No vipupisteet have been looked for yet. Run Find the vipupisteet first.',
      failed: 'Did not pass: {{list}}',
      held: 'Stays shown: {{count}} solutions are written on it.',
      judged: 'Judge: {{passed}} / {{total}} tests passed',
      tests: { kausaalisuus: 'causality', toimijuus: 'agency', todennettavuus: 'verifiability', spesifisyys: 'specificity', ratkaisuavoimuus: 'openness to solutions' },
      validators: {
        id_eheys: 'references do not match', huoneen_kattavuus: 'too few root causes the participants accepted',
        lainaus_ei_lahteessa: 'a quote is not in its source', instrumentti_ei_lahteessa: 'the instrument is not in a source',
        kriteeri_puuttuu: 'a part is missing', viite_ilman_lahdetta: 'a section or statute without a source',
        lahteistys_riittamaton: 'too few sources', testi_kausaalisuus: 'the causal link does not convince',
        testi_toimijuus: 'no one can act on it', testi_todennettavuus: 'not verifiable', testi_spesifisyys: 'too general',
      },
    },
  },
};

export const ongelmakarttaV3Sv = {
  pivots: 'Hävstångspunkter',
  list: {
    empty: 'Inga hävstångspunkter har sökts ännu.',
    intro: 'Kuutios förslag: AI formulerade dessa från deltagarnas grundorsaker och deras källor. Tryck på en för att se varför.',
    sections: { konsensus: 'Gemensamma synsätt', kiistanalainen: 'Omstridda', villi_kortti: 'Jokrar', sokea_piste: 'Blinda fläckar' },
    leads: {
      konsensus: 'Instrument som flera grundorsaker delar och som deltagarna anser träffande.',
      kiistanalainen: 'Deltagarnas bedömningar går isär här, eller grundorsakerna vill flytta samma instrument åt olika håll: värt att diskutera varför.',
      villi_kortti: 'Grundorsaker som inget gemensamt instrument håller, som deltagarna ännu inte stöder eller som ett par lade till själv: oväntade hävstänger.',
      sokea_piste: 'Kuutio har analyserat workshopen, och utifrån litteraturen och forskningen kan dessa vara gruppens blinda fläckar.',
    },
    reach: '{{juurisyyt}} grundorsaker · {{ongelmat}} problem',
    sources: '{{n}} källor',
    score: 'Poäng',
    split: 'Delad {{n}}/100',
    openTitle: 'Öppna frågor',
    openLead: 'Flera grundorsaker delar dessa mekanismer, men inget instrument hittades för dem. De är frågor för deltagarna, inte hävstångspunkter.',
    openReach: '{{n}} grundorsaker',
  },
  all: 'Problemkartläggning',
  voteTab: 'Omröstning',
  vote: {
    notOpen: 'Omröstningen är inte öppen ännu. Facilitatorn öppnar den när hävstångspunkterna har gåtts igenom.',
    open: 'Välj de hävstångspunkter du vill arbeta vidare med: {{left}} av {{max}} röster kvar. Tryck igen för att ta tillbaka en röst.',
    closed: 'Omröstningen är stängd: {{voters}} enheter röstade. Rösterna styr diskussionen; facilitatorn väljer vad som går vidare.',
    noneLeft: 'Alla {{max}} röster är givna. Ta tillbaka en för att välja en annan.',
    votes: '{{count}} röster',
    chosen: 'Vald att gå vidare',
  },
  pivotsCount: 'Hävstångspunkter, {{count}} hävstångspunkter',
  replayEntry: 'Spela upp animationen igen',
  mapDynamic: 'Kartläge: Dynamiskt',
  mapStatic: 'Kartläge: Statiskt',
  resetLayout: 'Återställ layouten',
  loading: 'Problemkartan laddas…',
  empty: 'Det finns inga problem på kartan än.',
  error: 'Problemkartan kunde inte laddas',
  pivot: {
    close: 'Stäng',
    types: { konsensus: 'Gemensam syn', kiistanalainen: 'Omstridd', villi_kortti: 'Joker', sokea_piste: 'Blind fläck' },
    precision: { pykala: 'Paragrafnivå', saados: 'Författningsnivå', mekanismi: 'Mekanism', rakenne: 'Struktur' },
    aiMark: 'Kuutios förslag: AI formulerade detta från deltagarnas grundorsaker och deras källor',
    blindSpotIntro: 'Kuutio har analyserat workshopen, och utifrån litteraturen och forskningen kan dessa vara gruppens blinda fläckar.',
    reworded: 'Omformulerad som hävstång',
    solutionWorded: 'Formuleringen liknar fortfarande en lösning',
    vagueWording: 'Rubriken är fortfarande vag eller lång',
    instrument: 'Instrument',
    instrumentTypes: { saantely: 'Reglering', rahoitus: 'Finansiering', organisaatio: 'Organisation', sosiaalinen: 'Social', narratiivi: 'Narrativ', tekninen: 'Teknisk' },
    owner: 'Ägare',
    ownerUnlisted: 'inte på workshopens aktörslista',
    mandate: { aihe: 'förvaltar ämnet', toimeksiantaja: 'på uppdragsgivarens lista' },
    direction: 'Förändringsriktning',
    directions: {
      vahennetaan: 'Minska', lisataan: 'Öka', tehdaan_nakyvaksi: 'Synliggöra', siirretaan_vastuuta: 'Flytta ansvar',
      avataan: 'Öppna', puretaan: 'Avveckla', tiukennetaan: 'Skärpa', kevennetaan: 'Lätta',
    },
    state: 'Tillståndsvariabel',
    stateNow: 'Läget nu',
    hiddenState: 'Ett dolt tillstånd, inte direkt observerbart',
    metric: 'Närmaste indikator',
    metricMissing: { ei_mitattu: 'indikatorn är bara föreslagen', ei_mittaria: 'ingen indikator' },
    resisters: 'Vem kunde motsätta sig',
    loses: 'skulle förlora',
    quotes: 'Citat',
    evidence: 'Belägg',
    supports: 'stöder',
    notSupported: 'stöder inte sitt påstående',
    sourceKinds: { rag: 'Forskning', web: 'Webb', juurisyy: 'Grundorsak' },
    reach: 'Räckvidd',
    reachLine: '{{juurisyyt}} grundorsaker · {{esteet}} hinder · {{ongelmat}} problem · {{linssit}} linser',
    rootCauses: 'Grundorsaker',
    signal: 'Deltagarnas signal',
    approval: 'Andel Osuu {{n}}/100',
    opposite: 'grundorsakerna vill flytta den åt olika håll',
    score: 'Poäng',
    total: 'Totalt',
    none: 'inga uppgifter',
    parts: { konvergenssi: 'Konvergens', linssihajonta: 'Linsernas spridning', naytto: 'Belägg', validointi: 'Deltagarnas bedömning', toimijuus: 'Handlingsutrymme', mitattavuus: 'Mätbarhet', katkaisee_silmukan: 'Bryter en slinga' },
    split: 'Oenighet',
    splitHelp: 'Hur jämnt deltagarnas Osuu- och Ei osu-bedömningar fördelar sig (1 = helt jämnt). Ingår inte i poängen.',
    values: 'Värdeval',
    tests: 'Tester',
    codeOnly: 'Kontrollerad endast av kod: hänvisningar, källor, ägare och formulering. AI-bedömaren användes inte.',
    testNames: { kausaalisuus: 'Kausalitet', toimijuus: 'Handlingsutrymme', todennettavuus: 'Verifierbarhet', spesifisyys: 'Specificitet', ratkaisuavoimuus: 'Lösningsöppenhet' },
    solutionExamples: 'Olika lösningar som kunde flytta denna hävstång',
    whyBlind: 'Varför deltagarna kanske inte ser detta',
  },
  admin: {
    title: 'Problemkartläggning: hävstångspunkter',
    actors: 'Aktörslista',
    actorsLead: 'En hävstångspunkts ägare och motståndare väljs endast från denna lista. Den börjar från Grundinformationens nyckelaktörer; lägg till namnen grundorsakerna använder för samma aktör.',
    name: 'Namn',
    aliases: 'Andra namn (kommaseparerade)',
    aihe: 'Förvaltar ämnet',
    toimeksiantaja: 'På uppdragsgivarens lista',
    add: 'Lägg till en aktör',
    save: 'Spara',
    remove: 'Ta bort',
    saved: 'Sparat',
    failed: 'Det gick inte att spara: {{error}}',
    unmatched: 'Omatchade namn',
    unmatchedLead: 'Grundorsakerna nämner dessa aktörer, men de matchar ingen på listan. Lägg till som aktör eller som en annan aktörs namn; nästa körning matchar dem.',
    noUnmatched: 'Den senaste körningen hade inga omatchade namn.',
    usedBy: 'i {{n}} grundorsaker',
    addAsActor: 'Lägg till som aktör',
    addAsAliasOf: 'Lägg till som namn på:',
    choose: 'Välj en aktör',
    runs: 'Körningar',
    noRuns: 'Inga hävstångspunkter har sökts ännu.',
    status: { running: 'pågår', done: 'klar', budget: 'tidsgränsen nåddes', failed: 'misslyckades' },
    runLine: '{{accepted}} godkända / {{generated}} · {{minutes}} min',
    preview: 'förhandsvisning: deltagarna ser den inte',
    exportXlsx: 'Exportera Excel',
    exportFull: 'Exportera fullständigt (innehåller enhets-id)',
    loadFailed: 'Kunde inte laddas: {{error}}',
    estimate: {
      title: 'Nästa körning',
      none: 'Ingen uppskattning ännu: inga tidigare körningar finns. Gräns {{limit}} min; körningen slutar där med de hävstångspunkter som är klara då.',
      judgeOff: 'Domare av', judgeOn: 'Domare på',
      models: { sonnet: 'Sonnet 5.5', opus: 'Opus 5.5' },
      cell: 'cirka {{minutes}} min', cellOver: 'över {{limit}} min: slutar vid tidsgränsen', unknown: 'inte mätt ännu',
      prepared: 'Förberett i bakgrunden: {{prepared}} av {{total}} grundorsaker lästa och deras instrument sökt. Kuutio förbereder nya grundorsaker själv när de har lämnats orörda en stund, så att körningen hinner med hävstångspunkterna.',
      basis: '{{rootCauses}} grundorsaker, varav {{unread}} olästa. Uppskattat från {{runs}} tidigare körningar ({{ownRuns}} i den här workshopen, som anger materialets storlek), domarens andel från {{judgedRuns}} körningar med domare; Opus hastighet från {{opusCalls}} uppmätta anrop. Modellen gäller formuleringen, domaren och de blinda fläckarna. Tidsgräns {{limit}} min: körningen slutar där med de hävstångspunkter som är klara då.',
    },
    vote: {
      title: 'Omröstning och valda hävstångspunkter',
      noRun: 'Inga hävstångspunkter ännu. Kör först Sök hävstångspunkter.',
      status: {
        none: 'Omröstningen har inte öppnats.',
        open: 'Omröstningen är öppen: {{max}} röster per enhet, {{voters}} enheter har röstat. Deltagarna ser inte rösterna förrän du stänger den.',
        closed: 'Omröstningen är stängd: {{voters}} enheter röstade. Deltagarna ser rösterna.',
      },
      maxVotes: 'Röster per enhet',
      votesEach: '{{count}} röster per enhet',
      open: 'Öppna omröstningen',
      reopen: 'Öppna omröstningen igen',
      close: 'Stäng omröstningen',
      chooseLead: 'Välj de hävstångspunkter som ni arbetar vidare med. Rösterna är vägledande; valet är ditt. De valda är modulens utdata för nästa steg.',
      votes: '{{count}} röster',
      save: 'Spara de valda ({{count}})',
      saved: 'Sparat: {{count}} valda hävstångspunkter',
      noneSaved: 'Inget val sparat ännu.',
    },
    choice: {
      title: 'Hävstångspunkter som visas',
      lead: 'Den senaste körningens hävstångspunkter: deltagarna ser {{shown}} av {{total}}. Som standard visas de bästa som klarade kontrollen, så många av varje typ som valts; körningen gör fler, och de, även de avvisade, kan visas härifrån. Ett val sparas direkt och syns på kartan, i lösningarna och i framtidstestningen.',
      noRun: 'Inga hävstångspunkter har sökts ännu. Kör först Hitta hävstångspunkterna.',
      failed: 'Klarade inte: {{list}}',
      held: 'Förblir synlig: {{count}} lösningar är skrivna på den.',
      judged: 'Domare: {{passed}} / {{total}} test godkända',
      tests: { kausaalisuus: 'orsakssamband', toimijuus: 'aktörskap', todennettavuus: 'verifierbarhet', spesifisyys: 'specificitet', ratkaisuavoimuus: 'öppenhet för lösningar' },
      validators: {
        id_eheys: 'hänvisningarna stämmer inte', huoneen_kattavuus: 'för få grundorsaker som deltagarna godkänt',
        lainaus_ei_lahteessa: 'ett citat finns inte i källan', instrumentti_ei_lahteessa: 'medlet finns inte i en källa',
        kriteeri_puuttuu: 'en del saknas', viite_ilman_lahdetta: 'en paragraf eller författning utan källa',
        lahteistys_riittamaton: 'för få källor', testi_kausaalisuus: 'orsakssambandet övertygar inte',
        testi_toimijuus: 'ingen kan agera på den', testi_todennettavuus: 'inte verifierbar', testi_spesifisyys: 'för allmän',
      },
    },
  },
};
